<div class="notification-panel">
    <div class="message" *ngFor="let message of messageList">
        {{message}}
    </div>
    <a (click)="sendMessage()">Send</a>
</div>